type Props = Readonly<{
  className?: string;
}>;

export function Farcaster({ className }: Props): JSX.Element {
  return (
    <svg
      className={`fill-black dark:fill-white ${className}`}
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.43194 0.820312H16.3313V3.42623H20L19.2308 6.03218H18.5799V16.5744C18.9067 16.5744 19.1716 16.8395 19.1716 17.1666V17.8773H19.2899C19.6167 17.8773 19.8817 18.1425 19.8817 18.4696V19.1803H13.2545V18.4696C13.2545 18.1425 13.5194 17.8773 13.8462 17.8773H13.9645V17.1666C13.9645 16.8801 14.1678 16.6411 14.4378 16.5862V10.7702H14.4193C14.21 8.44589 12.2583 6.62442 9.88163 6.62442C7.50494 6.62442 5.55327 8.44589 5.34399 10.7702H5.32543V16.5744H5.44377C5.77056 16.5744 6.0355 16.8395 6.0355 17.1666V17.8773H6.15383C6.48063 17.8773 6.74554 18.1425 6.74554 18.4696V19.1803H0.118331V18.4696C0.118331 18.1425 0.383272 17.8773 0.710067 17.8773H0.828398V17.1666C0.828398 16.8395 1.09331 16.5744 1.42011 16.5744V6.03218H0.769232L0 3.42623H3.43194V0.820312Z"
        fill="fill-black"
      />
    </svg>
  );
}
